import * as React from "react";

export class Item extends React.Component<{ handler?: Function, label: string, url: string }, {}> {
    /* istanbul ignore next */
    void(): void { }
    render() {
        let h = this.props.handler || this.void;
        return (
            <div className="rj-racing-next-races__item">
                {this.props.children}
                <a className="rj-racing-next-races__view"
                    href={this.props.url}
                    onClick={/* istanbul ignore next */(event) => h(event)}>
                    {this.props.label}
                </a>
            </div>
        );
    }
}